import { render } from "./LinkdinIcon.vue?vue&type=template&id=554cb464"
import script from "./LinkdinIcon.vue?vue&type=script&lang=js"
export * from "./LinkdinIcon.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__